export class BannerImage {
    idStr: number;
    nameStr: string;
    valStr: string;
}